import React, { useEffect, useState } from "react";

const ROLES = [
  "Traders",
  "Investors",
  "Brokers",
  "Fund Managers",
  "Financial Advisors",
  "Legal Advisors",
  "Mutual Fund Advisors",
  "Analysts",
  "Mentors",
  "Educators",
  "Signal Providers",
  "Strategy Developers",
  "FinTech Builders",
  "Platform Developers",
  "Content Creators",
  "Influencers",
  "Insurance Professionals",
  "Freelancers",
  "Event Organizers",
  "Market Journalists",
  "Media Advertisers",
  "Market Experts",
  "Institutional Players",
  "Capital Providers",
  "Career Consultants",
  "Job Seekers",
  "Recruiters",
  "Market Tool Providers",
  "Finance Support Services",
  "Blockchain Experts",
  "Angel Investors",
  "Venture Capitalists",
];

export default function MarketRolesSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % ROLES.length);
    }, 1200);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="w-full bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-4">
        {/* HEADER */}
        <div className="mb-12 max-w-3xl">
          <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
            Any Market. Any Role.{" "}
            <span className="text-blue-600">One Network.</span>
          </h2>

          <p className="mt-2 text-sm text-gray-400 sm:text-base">
            Whether you are a trader, investor, broker, advisor, or capital
            provider — Million2Trillion connects every verified market
            professional into one trusted global ecosystem.
          </p>
        </div>

        {/* ROLES GRID */}
        <div className="grid grid-cols-2 gap-x-12 gap-y-7 md:grid-cols-3 lg:grid-cols-4">
          {ROLES.map((role, index) => {
            const isActive = index === activeIndex;

            return (
              <div
                key={index}
                className="relative flex items-center transition-all duration-500"
              >
                {/* Animated Online Dot */}
                {isActive && (
                  <span className="absolute -left-5 flex h-3 w-3">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
                    <span className="relative inline-flex h-3 w-3 rounded-full bg-emerald-500 shadow-[0_0_12px_#22c55e]"></span>
                  </span>
                )}

                <span
                  className={`text-sm transition-all duration-300 md:text-base ${
                    isActive
                      ? "font-semibold tracking-wide text-white"
                      : "text-gray-500 hover:text-gray-300"
                  }`}
                >
                  {role}
                </span>
              </div>
            );
          })}
        </div>

        {/* FOOTER */}
        <div className="mt-16 text-sm text-white">
          No matter your role. No matter your market. Stay connected to the
          world’s largest verified professional market network.
        </div>
      </div>
    </section>
  );
}
